import React from 'react';
import './IQAC.css';

const IQAC = () => (
  <div className="page-container dark-red-theme">
    <h2>IQAC</h2>
    <p>Dummy content for IQAC page.</p>
  </div>
);

export default IQAC;
